import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const useAlbum = (urlId = null, swrOptions) => {
  const { data, ...rest } = useCustomSWR(
    urlId && `/albums?${stringify({ urlId })}`,
    swrOptions
  )
  return { data: data?.[0], ...rest }
}
